import { api } from "../api/requests";

// Generate payment receipt for motor policy
export function generatePaymentReceipt(policyNumber: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
        api.get(`/admin/policies/${policyNumber}/generate-payment-receipt`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: Error) => {
                reject(error);
            });
    });
}


// Complete policy data
export function completePolicyInformation(policyNumber: string, payload: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
        api.post(`/admin/policies/${policyNumber}/complete`, payload)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: Error) => {
                reject(error);
            });
    });
}